import React, { useEffect } from "react";
import { Card, Button } from "react-bootstrap";

type GetLocationProps = {
  status: "loading" | "allowed" | "denied";
};

const GetLocation: React.FC<GetLocationProps> = ({ status }) => {
  const detectBrowser = () => {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.includes("edg")) return "edge";
    if (ua.includes("chrome")) return "chrome";
    if (ua.includes("firefox")) return "firefox";
    if (ua.includes("safari")) return "safari";
    return "unknown";
  };

  const EnableLocationSteps = () => {
    const browser = detectBrowser();

    const steps: Record<string, React.ReactNode> = {
      chrome: (
        <ol className="list-unstyled m-0">
          <li>Click the 🔒 lock icon in the address bar</li>
          <li>
            Set <strong>Location</strong> to <strong>Allow</strong>
          </li>
          <li>Reload the page</li>
        </ol>
      ),
      firefox: (
        <ol className="list-unstyled m-0">
          <li>Click the 🔒 icon in the address bar</li>
          <li>
            Allow <strong>Location</strong>
          </li>
          <li>Reload the page</li>
        </ol>
      ),
      safari: (
        <ol className="list-unstyled m-0">
          <li>Safari → Settings → Websites → Location</li>
          <li>Allow this site</li>
          <li>Reload the page</li>
        </ol>
      ),
      unknown: (
        <ol className="list-unstyled m-0">
          <li>Open browser settings</li>
          <li>Allow location for this site</li>
          <li>Reload the page</li>
        </ol>
      ),
    };

    return (
      <div className="text-center mt-3 text-muted">
        <h6>
          How to enable location in{" "}
          <strong>{browser === "unknown" ? "your browser" : browser}</strong>
        </h6>
        {steps[browser]}
      </div>
    );
  };

  useEffect(() => {
    document.body.style.overflow = status === "allowed" ? "auto" : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [status]);

  if (status === "allowed") return null;

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f5f5",
        zIndex: 10,
      }}
    >
      <Card className="border-0" style={{ maxWidth: 480, width: "100%" }}>
        <Card.Body className="text-center py-5">
          {status === "loading" ? (
            <h5>Fetching your location…</h5>
          ) : (
            <>
              <h4>Location Access Required</h4>
              <p className="text-muted">
                We need your location to show bidding details near you.
              </p>
              <EnableLocationSteps />
              <Button
                className="mt-3"
                variant="success"
                onClick={() => window.location.reload()}
              >
                Reload Page
              </Button>
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default GetLocation;
